import { HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';
import { AxiosRequestConfig } from 'axios';
import { ViewSettingsCache } from './view-settings-cache';
import { ConfigType } from './view-settings-types';

interface ViewSetting { value: string; }

export class ViewSettingsRepositoryBase {
    private static Url = TaggedUrl.join('user/:action', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async getViewSettingsAsync<TValue = any>(key: ConfigType): Promise<TValue> {
        const cacheData = ViewSettingsCache.cache.get(key);
        if (cacheData && cacheData.config !== void 0) {
            return cacheData.config;
        }
        const url = fillPlaceholders(ViewSettingsRepositoryBase.Url, { action: 'settings' });
        const config: AxiosRequestConfig = {
            params: { key: key },
        };
        const response = await this.http.get<ViewSetting>(url, config);
        const value = JSON.parse(response.data.value);
        ViewSettingsCache.cache.put(key, { config: value });
        return <TValue>value;
    }

    public async saveViewSettingsAsync<T>(key: ConfigType, viewConfig: T): Promise<void> {
        ViewSettingsCache.cache.put(key, { config: viewConfig });
        const url = fillPlaceholders(ViewSettingsRepositoryBase.Url, { action: 'settings' });
        const config: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            params: { key: key },
        };
        await this.http.put<void>(url, { value: JSON.stringify(viewConfig) }, config);
    }
}
